import React, { Component } from 'react'
import Transport from './Transport'
import { message } from 'antd'
import { pick } from 'lodash'
import Orders from '../../../../api/Sales/Orders'
import moment from 'moment'
import CSVTOJSON from 'csvtojson'


class TransportCont extends Component {
  componentDidMount() {
    this.fetch()
    this.fetchDeliveries()
    this.fetchVehicles()
  }

  state = {
    deliveryLine: {},
    salikUploadList: [],
  }
  formRef = React.createRef()
  vehicleFormRef = React.createRef()
  salikFormRef = React.createRef()
  api = new Orders()
  fileReader = new FileReader()
  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const bookings = await this.api.bookings()
      this.setState({
        bookings,
        fetching: false,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        fetching: false,
      })
    }
  }
  fetchDeliveries = async () => {
    try {
      this.setState({
        fetchingDeliveries: true,
      })
      const deliveries = await this.api.deliveries()
      this.setState({
        deliveries,
        fetchingDeliveries: false,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        fetchingDeliveries: false,
      })
    }
  }
  fetchVehicles = async () => {
    try {
      this.setState({
        fetchingVehicles: true,
      })
      const vehicles = await this.api.vehicles.list()
      this.setState({
        vehicles,
        fetchingVehicles: false,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        fetchingVehicles: false,
      })
    }
  }
  fetchSalik = async () => {
    try {
      this.setState({
        fetchingSalik: true,
      })
      const salikList = await this.api.salik.list()
      this.setState({
        salikList,
        fetchingSalik: false,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        fetchingSalik: false,
      })
    }
  }
  onShowDelivery = (orderLine) => {
    this.setState({
      visibleDelivery: true,
      orderLine,
    })
  }
  onCancelDelivery = () => {
    this.setState({
      visibleDelivery: false,
    })
  }
  onDeliverBooking = async () => {
    const deliveryLine = await this.checkForm()
    try {
      this.setState({
        submittingDelivery: true,
      })
      const { orderLine } = this.state
      await this.api.lines.deliver({
        orderLine: pick(orderLine, ['_id']),
        ...deliveryLine,
      })

      this.setState({
        submittingDelivery: false,
      })
      this.onCancelDelivery()
      this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        submittingDelivery: false,
      })
    }
  }
  onSalikUpload = async () => {
    const values = await this.checkSalikForm()
    let salikUploadList = [...this.state.salikUploadList]
    salikUploadList = salikUploadList.map((salik) => {
      const d = {
        tripDate: moment(salik.tripDate, 'DD MMM YYYY').format('YYYY-MM-DD'),
        postDate: moment(salik.postDate, 'DD MMM YYYY').format('YYYY-MM-DD'),
        amount: parseFloat(salik.amount),
        account: values.account,
        _key: salik.salikId,
      }
      return {
        ...pick(salik, [
          'salikId',
          'tripDate',
          'tripTime',
          'postDate',
          'tollGate',
          'direction',
          'tag',
          'plate',
          'amount',
          'account',
        ]),
        ...d,
      }
    })
    try {
      this.setState({
        submittingSalik: true,
      })
      await this.api.salik.upload(salikUploadList)
      this.setState({
        submittingSalik: false,
      })
      this.onCancelSalik()
      this.fetchSalik()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        submittingSalik: false,
      })
    }
  }
  checkForm = () => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFields((err, values) => {
        if (!err) {
          res(values)
        }
      })
    })
  }
  checkSalikForm = () => {
    return new Promise((res, rej) => {
      this.salikFormRef.current.validateFields((err, values) => {
        if (!err) {
          res(values)
        }
      })
    })
  }
  onShowVehicle = (vehicle) => {
    this.setState({
      visibleVehicle: true,
      vehicle,
    })
  }
  onCancelVehicle = () => {
    this.setState({
      visibleVehicle: false,
    })
  }
  updateVehicle = async () => {
    const vehicle = await this.checkVehicleForm()
    try {
      this.setState({
        submittingVehicle: true,
      })
      await this.api.vehicles.update({
        ...vehicle,
        ...pick(this.state.vehicle, ['_id', '_rev']),
      })
      this.setState({
        submittingVehicle: false,
      })
      this.onCancelVehicle()
      this.fetchVehicles()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        submittingVehicle: false,
      })
    }
  }
  checkVehicleForm = () => {
    return new Promise((res, rej) => {
      this.vehicleFormRef.current.validateFields((err, values) => {
        if (!err) {
          res(values)
        }
      })
    })
  }
  onShowSalik = () => {
    this.setState({
      visibleSalik: true,
    })
  }
  onCancelSalik = () => {
    this.setState({
      visibleSalik: false,
      salikUploadList: [],
      csvFileList: [],
    })
  }
  onFileLoadEnd = async () => {
    try {
      const content = this.fileReader.result
      const salikUploadList = await CSVTOJSON().fromString(content)
      this.setState({
        salikUploadList,
      })
    } catch (e) {
      message.error(e.errorMessage)
    }
  }
  onFileLoaded = async ({ file }) => {
    this.fileReader.onloadend = this.onFileLoadEnd
    if (file) {
      await this.fileReader.readAsText(file)
    }
  }
  beforeUpload = (file) => {
    this.setState({
      csvFileList: [file],
    })
    return false
  }

  render() {
    return (
      <Transport
        {...this.state}
        {...pick(this, [
          'fetch',
          'fetchDeliveries',
          'fetchVehicles',
          'fetchSalik',
          'formRef',
          'salikFormRef',
          'vehicleFormRef',
          'onChangeAccount',
          'onShowSalik',
          'onShowDelivery',
          'onShowVehicle',
          'onCancelVehicle',
          'updateVehicle',
          'onDeliverBooking',
          'onCancelDelivery',
          'onFileLoaded',
          'onSalikUpload',
          'beforeUpload',
          'onCancelSalik',
        ])}
      />
    )
  }
}

TransportCont.propTypes = {}
TransportCont.defaultProps = {}

export default (TransportCont)
